import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {
  DeselectFloorSuccess,
  FloorPlanViewActionTypes,
  SelectAirComponent,
  SelectFloor,
  UpdateSelectedAirComponent,
  UpdateSelectedFloor
} from '../actions/floor-plan-view.actions';
import {map} from 'rxjs/operators';
import {SelectFloorPayload} from '../models/floor-plan';
import {AirComponentType} from '../../afb-api/enums/air-component-type.enum';

@Injectable()
export class FloorPlanViewEffects {

  @Effect()
  selectFloor$ = this.actions$.pipe(
    ofType(FloorPlanViewActionTypes.SelectFloor),
    map((action: SelectFloor) => action.payload),
    map((selectFloorPayload: SelectFloorPayload) => new UpdateSelectedFloor(selectFloorPayload))
  );

  @Effect()
  deselectFloor$ = this.actions$.pipe(
    ofType(FloorPlanViewActionTypes.DeselectFloor),
    map(() => new DeselectFloorSuccess())
  );

  @Effect()
  selectAirComponent$ = this.actions$.pipe(
    ofType(FloorPlanViewActionTypes.SelectAirComponent),
    map((action: SelectAirComponent) => action.payload),
    map((airComponentType: AirComponentType) => new UpdateSelectedAirComponent(airComponentType))
  );

  constructor(private actions$: Actions) {
  }
}
